/* eslint-env es6 */
export const actions = {
  setKeyWord (context, keyValue) {
    console.log('actions')
    console.log(keyValue)
    context.commit('setKeyWord', keyValue)
  }
}
